import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

const SortTypeSelectionMenu = ({
  optionsMap,
  sortingOrder,
  setStateOnChange,
  setSortKey,
}: {
  optionsMap;
  sortingOrder;
  setStateOnChange;
  setSortKey?;
}) => {
  return (
    <FormControl sx={{ float: 'right', minWidth: '240px' }}>
      <InputLabel id="sort-order-menu">Sort By</InputLabel>
      <Select
        id="sort-order-menu"
        value={sortingOrder}
        label="Sort By"
        onChange={event => {
          const selectedOption = event.target.value;
          setStateOnChange(selectedOption);
          const currentOptionSortyKeyFromMap = optionsMap[selectedOption]?.sortKey;
          setSortKey && currentOptionSortyKeyFromMap && setSortKey(currentOptionSortyKeyFromMap);
        }}
      >
        {Object.keys(optionsMap).map(sortKey => (
          <MenuItem value={sortKey}>{optionsMap[sortKey]['displayName']}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SortTypeSelectionMenu;
